import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=675eb0da&scoped=true&"
import script from "./Recap.vue?vue&type=script&lang=js&"
export * from "./Recap.vue?vue&type=script&lang=js&"
import style0 from "./Recap.vue?vue&type=style&index=0&id=675eb0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675eb0da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
